var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.inputValue)?_c('div',{staticClass:"modal-mask",on:{"click":function($event){_vm.inputValue = false}}},[_c('div',{staticClass:"modal",style:({
      top : _vm.top,
      left : _vm.left,
      width :_vm.width,
      height : _vm.height,
    }),on:{"click":_vm.modalClick}},[_vm._t("default")],2)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2ff4aaa","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shell/components/Modal.vue
// module id = 252
// module chunks = 0